import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "market-dashboard"
};
const _hoisted_2 = {
  key: 0,
  class: "error-message"
};
const _hoisted_3 = {
  class: "left-section"
};
const _hoisted_4 = {
  class: "dashboard-card mood"
};
const _hoisted_5 = {
  class: "mood-header"
};
const _hoisted_6 = {
  class: "update-time"
};
const _hoisted_7 = {
  class: "mood-grid"
};
const _hoisted_8 = {
  class: "card-title"
};
const _hoisted_9 = {
  class: "card-value"
};
const _hoisted_10 = {
  class: "dashboard-card sectors"
};
const _hoisted_11 = {
  class: "sector-wrapper"
};
const _hoisted_12 = {
  class: "sector-content"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "plate-info"
};
const _hoisted_15 = {
  class: "plate-name"
};
const _hoisted_16 = {
  class: "plate-change"
};
const _hoisted_17 = {
  class: "stock-list"
};
const _hoisted_18 = {
  class: "stock-name"
};
const _hoisted_19 = {
  class: "stock-change"
};
const _hoisted_20 = {
  class: "sector-wrapper"
};
const _hoisted_21 = {
  class: "sector-content"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "plate-info"
};
const _hoisted_24 = {
  class: "plate-name"
};
const _hoisted_25 = {
  class: "plate-change"
};
const _hoisted_26 = {
  class: "stock-list"
};
const _hoisted_27 = {
  class: "stock-name"
};
const _hoisted_28 = {
  class: "stock-change"
};
const _hoisted_29 = {
  class: "right-section"
};
const _hoisted_30 = {
  class: "dashboard-card limit-up"
};
const _hoisted_31 = {
  class: "card-header flex items-center justify-start"
};
const _hoisted_32 = {
  class: "m-0 p-0"
};
const _hoisted_33 = {
  key: 0,
  class: "plate-details-display px-2 pt-0 pb-2 overflow-y-auto h-full mt-0"
};
const _hoisted_34 = {
  class: "plate-stocks-list"
};
const _hoisted_35 = {
  class: "text-base font-semibold px-2 py-1 bg-gray-100 mt-2 border-b border-gray-200 rounded-t-md"
};
const _hoisted_36 = {
  class: "flex justify-between items-start"
};
const _hoisted_37 = {
  class: "flex flex-col w-1/6 pr-1"
};
const _hoisted_38 = {
  class: "flex items-baseline mb-1"
};
const _hoisted_39 = {
  class: "font-bold text-gray-800 text-base leading-tight"
};
const _hoisted_40 = {
  key: 0,
  class: "text-xs text-gray-500 mb-1"
};
const _hoisted_41 = {
  class: "text-xs text-gray-500 mb-1"
};
const _hoisted_42 = {
  class: "flex flex-wrap items-baseline"
};
const _hoisted_43 = {
  key: 1,
  class: "ml-1 px-1 py-0 text-xs font-semibold rounded-sm bg-red-100 text-red-800 border border-red-300 leading-tight"
};
const _hoisted_44 = {
  class: "flex flex-col w-1/4 px-1 text-sm text-gray-700"
};
const _hoisted_45 = {
  class: "flex justify-between mb-1"
};
const _hoisted_46 = {
  key: 0,
  class: "whitespace-nowrap"
};
const _hoisted_47 = {
  key: 1,
  class: "whitespace-nowrap"
};
const _hoisted_48 = {
  class: "flex justify-between"
};
const _hoisted_49 = {
  key: 0,
  class: "whitespace-nowrap"
};
const _hoisted_50 = {
  key: 1,
  class: "whitespace-nowrap"
};
const _hoisted_51 = {
  class: "flex flex-col w-7/12 pl-1"
};
const _hoisted_52 = {
  class: "text-xs text-gray-500 text-left"
};
const _hoisted_53 = {
  key: 1
};
const _hoisted_54 = {
  class: "limit-table"
};
const _hoisted_55 = {
  class: "sort-icon"
};
const _hoisted_56 = {
  class: "sort-icon"
};
const _hoisted_57 = {
  class: "sort-icon"
};
const _hoisted_58 = {
  class: "sort-icon"
};
const _hoisted_59 = {
  class: "sort-icon"
};
const _hoisted_60 = {
  class: "sort-icon"
};
const _hoisted_61 = {
  class: "sort-icon"
};
const _hoisted_62 = {
  class: "sort-icon"
};
const _hoisted_63 = {
  class: "sort-icon"
};
const _hoisted_64 = {
  class: "sort-icon"
};
const _hoisted_65 = {
  class: "index-cell"
};
const _hoisted_66 = {
  class: "stock-name-cell"
};
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';

// 响应式状态

export default {
  __name: 'BigFish',
  setup(__props) {
    const marketData = ref({});
    const sectors = ref([]);
    const limitUpStocks = ref([]);
    const isOffline = ref(false);
    let fetchInterval = null;
    const selectedPlateDetails = ref(null); // 新增：用于存储选中板块的详情
    const leadingStocks = ref({}); // 新增：用于存储龙头股信息
    const stockLabels = ref({}); // 新增：用于存储个股标签信息
    const stockMarketData = ref({}); // 新增：用于存储个股行情数据

    // 市场数据标签映射优化
    const marketDataLabels = {
      market_temperature: '市场温度',
      rise_count: '上涨数',
      fall_count: '下跌数',
      limit_up_count: '涨停数',
      dt_board_and_limit_avg_pcp: '封板率',
      limit_up_broken_count: '破板数',
      limit_up_broken_ratio: '破板率',
      lianbangaodu: '连板高度',
      limit_down_count: '跌停数'
    };

    // 市场情绪板块的数据排序
    const sortedMarketData = computed(() => {
      const orderKeys = ['market_temperature', 'rise_count', 'fall_count', 'limit_up_count', 'dt_board_and_limit_avg_pcp', 'limit_up_broken_count', 'limit_up_broken_ratio', 'lianbangaodu', 'limit_down_count'];
      return orderKeys.reduce((acc, key) => {
        if (marketData.value[key] !== undefined) {
          acc[key] = marketData.value[key];
        }
        return acc;
      }, {});
    });
    const getMarketDataLabel = key => {
      return marketDataLabels[key] || key;
    };
    const formatMarketValue = (key, value) => {
      if (value === undefined || value === null) return '0';

      // 处理百分比
      if (key.includes('ratio') || key.includes('rate')) {
        if (Math.abs(value) < 0.0001) return '0%';
        return (value * 100).toFixed(2) + '%';
      }

      // 处理整数
      if (key.includes('count')) {
        return Math.round(value).toString();
      }

      // 处理金额
      if (key.includes('amount')) {
        if (value >= 100000000) {
          return Math.floor(value / 100000000) + '亿';
        }
        if (value >= 10000) {
          return Math.floor(value / 10000) + '万';
        }
        return Math.round(value).toString();
      }

      // 其他数字保留2位小数
      if (typeof value === 'number') {
        return value.toFixed(2);
      }
      return value;
    };
    const formatPercent = value => {
      if (value === undefined || value === null) return '0%';
      return value.toFixed(2) + '%';
    };
    const formatAmount = value => {
      if (!value) return '0';
      return value >= 100000000 ? (value / 100000000).toFixed(2) + '亿' : (value / 10000).toFixed(0) + '万';
    };

    // 更新数据方法
    const updateMarketData = data => {
      if (!data) return;
      marketData.value = {
        ...data,
        timestamp: Math.floor(Date.now() / 1000) // 添加当前时间戳（秒级）
      };
    };
    const updateSectorsData = data => {
      if (!data) return;
      sectors.value = data;
    };

    // 数据获取方法
    const fetchData = async () => {
      try {
        // 市场指标数据
        const marketResponse = await fetch('https://flash-api.xuangubao.com.cn/api/market_indicator/latest', {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          mode: 'cors'
        });
        const marketData = await marketResponse.json();
        if (marketData && marketData.data) {
          updateMarketData(marketData.data);
        }

        // 清空涨停板数据，不再显示在当前页面
        limitUpStocks.value = [];

        // 板块数据
        const sectorsResponse = await fetch('https://flash-api.xuangubao.com.cn/api/stage2/plate/top_info?count=10&fields=all', {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          mode: 'cors'
        });
        const sectorsData = await sectorsResponse.json();
        if (sectorsData && sectorsData.data) {
          updateSectorsData(sectorsData.data);
          // 新增：默认加载第一个领涨板块的详情
          if (sectorsData.data.top_plate_info && sectorsData.data.top_plate_info.length > 0) {
            fetchPlateDetails(sectorsData.data.top_plate_info[0].plate_id);
          }
        }
        isOffline.value = false;
      } catch (error) {
        console.error('数据获取失败:', error);
        isOffline.value = true;
      }
    };

    // 生命周期钩子
    onMounted(() => {
      fetchData();
      fetchInterval = setInterval(fetchData, 60000); // 60秒更新一次
    });
    onBeforeUnmount(() => {
      if (fetchInterval) {
        clearInterval(fetchInterval);
      }
    });

    // 添加排序相关的状态
    const sortConfig = ref({
      key: 'last_limit_up',
      // 默认按最后封板时间排序
      order: 'desc' // 'asc' 或 'desc'
    });

    // 排序方法
    const handleSort = key => {
      if (sortConfig.value.key === key) {
        sortConfig.value.order = sortConfig.value.order === 'asc' ? 'desc' : 'asc';
      } else {
        sortConfig.value.key = key;
        sortConfig.value.order = 'desc';
      }
    };

    // 获取排序图标
    const getSortIcon = key => {
      if (sortConfig.value.key !== key) return '⇅';
      return sortConfig.value.order === 'asc' ? '↑' : '↓';
    };

    // 修改时间格式化函数
    const formatTime = timestamp => {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000); // 将秒转换为毫秒
      return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    };

    // 排序后的股票列表
    const sortedStocks = computed(() => {
      const {
        key,
        order
      } = sortConfig.value;
      return [...limitUpStocks.value].sort((a, b) => {
        let valueA = a[key];
        let valueB = b[key];

        // 特殊处理某些字段
        if (key === 'flow_capital' || key === 'total_capital') {
          valueA = Number(valueA) || 0;
          valueB = Number(valueB) || 0;
        }
        if (order === 'asc') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });
    });

    // 添加完整时间格式化函数
    const formatFullTime = timestamp => {
      if (!timestamp) {
        timestamp = Math.floor(Date.now() / 1000); // 使用当前时间
      }
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    // 新增：合并个股标签和行情数据
    const mergeStockData = (stock, labels, marketData) => {
      // 合并标签
      if (labels && labels[stock.symbol]) {
        stock.labels = labels[stock.symbol];
        // 简化标签显示，只取第一个标签的name和effect
        if (stock.labels.length > 0) {
          stock.displayLabel = stock.labels[0].label_name;
          stock.labelEffect = stock.labels[0].effect; // 1:利好, -1:利空, 0:中性
        }
      }

      // 合并行情数据
      if (marketData && marketData[stock.symbol]) {
        Object.assign(stock, marketData[stock.symbol]);
      }
    };

    // 新增：获取板块详情
    const fetchPlateDetails = async plateId => {
      try {
        // 获取板块基本详情 (plate_set)
        const plateSetResponse = await fetch(`https://flash-api.xuangubao.com.cn/api/plate/plate_set?id=${plateId}&display_premium_stock=true`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          mode: 'cors'
        });
        const plateSetData = await plateSetResponse.json();
        if (plateSetData && plateSetData.data) {
          selectedPlateDetails.value = plateSetData.data;

          // 如果 industrial_chains 为空但 stocks 字段有数据，则将 stocks 转换为一个模拟的 industrial_chain
          if ((!selectedPlateDetails.value.industrial_chains || selectedPlateDetails.value.industrial_chains.length === 0) && selectedPlateDetails.value.stocks && selectedPlateDetails.value.stocks.length > 0) {
            selectedPlateDetails.value.industrial_chains = [{
              id: 'main_stocks',
              // 给这个模拟的产业链一个ID
              name: '主要成分股',
              // 给这个模拟的产业链一个名称
              stock_premium_infos: selectedPlateDetails.value.stocks
            }];
          }

          // 新增：将 industrial_chains 倒序
        } else {
          selectedPlateDetails.value = null;
        }

        // 获取龙头股数据 (plate/data)
        const plateDataResponse = await fetch(`https://flash-api.xuangubao.com.cn/api/plate/data?fields=jinrilongtou,renqilongtou,hangyelongtou,core_avg_pcp,plate_name,plate_id&plates=${plateId}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          mode: 'cors'
        });
        if (plateDataResponse.status === 204) {
          leadingStocks.value = {};
        } else {
          const plateData = await plateDataResponse.json();
          if (plateData && plateData.data && plateData.data[plateId]) {
            leadingStocks.value = plateData.data[plateId];
          } else {
            leadingStocks.value = {};
          }
        }

        // 标记龙头股
        if (selectedPlateDetails.value && selectedPlateDetails.value.industrial_chains) {
          selectedPlateDetails.value.industrial_chains.forEach(chain => {
            if (chain.stock_premium_infos) {
              chain.stock_premium_infos.forEach(stock => {
                stock.isLeading = false;
                if (leadingStocks.value.jinrilongtou && leadingStocks.value.jinrilongtou.includes(stock.symbol)) {
                  stock.isLeading = '今日龙头';
                } else if (leadingStocks.value.renqilongtou && leadingStocks.value.renqilongtou.includes(stock.symbol)) {
                  stock.isLeading = '人气龙头';
                } else if (leadingStocks.value.hangyelongtou && leadingStocks.value.hangyelongtou.includes(stock.symbol)) {
                  stock.isLeading = '行业龙头';
                }
              });
            }
          });
        }

        // 在标记龙头股之后，获取所有成分股的symbols
        const allSymbols = selectedPlateDetails.value.industrial_chains.flatMap(chain => chain.stock_premium_infos ? chain.stock_premium_infos.map(s => s.symbol) : []).join(',');
        if (allSymbols) {
          // 并发请求个股标签和行情数据
          const [labelsResponse, marketDataResponse] = await Promise.all([fetch(`https://flash-api.xuangubao.com.cn/api/stock_label/labels?symbols=${allSymbols}`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            mode: 'cors'
          }), fetch(`https://flash-api.xuangubao.com.cn/api/stock/data?symbols=${allSymbols}&fields=symbol,stock_chi_name,change_percent,price,turnover_ratio,non_restricted_capital,total_capital,per,limit_up_days,last_limit_up,limit_status,nearly_new_acc_pcp&strict=true`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            mode: 'cors'
          })]);
          const labelsData = await labelsResponse.json();
          const marketData = await marketDataResponse.json();
          if (labelsData && labelsData.data) {
            stockLabels.value = labelsData.data;
          } else {
            stockLabels.value = {};
          }
          if (marketData && marketData.data) {
            stockMarketData.value = marketData.data;
          } else {
            stockMarketData.value = {};
          }

          // Merge all fetched data into stock_premium_infos
          if (selectedPlateDetails.value && selectedPlateDetails.value.industrial_chains) {
            selectedPlateDetails.value.industrial_chains.forEach(chain => {
              if (chain.stock_premium_infos) {
                chain.stock_premium_infos.forEach(stock => {
                  mergeStockData(stock, stockLabels.value, stockMarketData.value);
                });
              }
            });

            // Apply multi-level sorting to stock_premium_infos after all data has been merged
            selectedPlateDetails.value.industrial_chains.forEach(chain => {
              if (chain.stock_premium_infos) {
                chain.stock_premium_infos.sort((a, b) => {
                  const a_has_limit_up = !!a.last_limit_up; // true if it has a limit-up time
                  const b_has_limit_up = !!b.last_limit_up; // true if it has a limit-up time

                  // 1. Primary sort: limit-up stocks come before non-limit-up stocks
                  if (a_has_limit_up !== b_has_limit_up) {
                    return b_has_limit_up ? -1 : 1; // Stocks with limit-up come first
                  }

                  // 2. If both are limit-up stocks: sort by limit-up time ascending (earliest first)
                  if (a_has_limit_up && b_has_limit_up) {
                    const timeA = a.last_limit_up;
                    const timeB = b.last_limit_up;

                    // Ensure time values are strings for localeCompare, treat non-strings as very "late" times for sorting
                    const normalizedTimeA = typeof timeA === 'string' ? timeA : 'ZZZZZZZ'; // Large string to sort last
                    const normalizedTimeB = typeof timeB === 'string' ? timeB : 'ZZZZZZZ';
                    return normalizedTimeA.localeCompare(normalizedTimeB);
                  }
                  // 3. If neither are limit-up stocks: sort by change percentage descending (highest first)
                  else {
                    const a_change = a.change_percent !== undefined ? a.change_percent : -Infinity;
                    const b_change = b.change_percent !== undefined ? b.change_percent : -Infinity;
                    return b_change - a_change;
                  }
                });
              }
            });
          }
        }
        console.log('板块详情:', selectedPlateDetails.value); // 方便调试
        console.log('龙头股数据:', leadingStocks.value); // 方便调试
        console.log('个股标签:', stockLabels.value); // 方便调试
        console.log('个股行情:', stockMarketData.value); // 方便调试
      } catch (error) {
        console.error('获取板块详情或龙头股失败:', error);
        selectedPlateDetails.value = null;
        leadingStocks.value = {};
        stockLabels.value = {};
        stockMarketData.value = {};
      }
    };
    return (_ctx, _cache) => {
      const _component_a_popover = _resolveComponent("a-popover");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [isOffline.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, "数据获取失败")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("section", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[10] || (_cache[10] = _createElementVNode("h2", null, "出门钓鱼去？", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(formatFullTime(marketData.value.timestamp)), 1)]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedMarketData.value, (value, key) => {
        return _openBlock(), _createElementBlock("div", {
          key: key,
          class: "mood-card"
        }, [_createElementVNode("div", _hoisted_8, _toDisplayString(getMarketDataLabel(key)), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(formatMarketValue(key, value)), 1)]);
      }), 128))])]), _createElementVNode("section", _hoisted_10, [_cache[13] || (_cache[13] = _createElementVNode("h2", null, "去哪钓鱼？", -1)), _createElementVNode("div", _hoisted_11, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "sector-header"
      }, "领涨板块", -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sectors.value.top_plate_info, plate => {
        var _plate$plate_name, _plate$led_rising_sto;
        return _openBlock(), _createElementBlock("div", {
          key: plate.plate_id,
          class: "data-item",
          onClick: $event => fetchPlateDetails(plate.plate_id)
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString((_plate$plate_name = plate.plate_name) === null || _plate$plate_name === void 0 ? void 0 : _plate$plate_name.substring(0, 4)), 1), _createElementVNode("span", _hoisted_16, _toDisplayString(formatPercent(plate.core_avg_pcp * 100)), 1)]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_plate$led_rising_sto = plate.led_rising_stocks) === null || _plate$led_rising_sto === void 0 ? void 0 : _plate$led_rising_sto.items.slice(0, 5), stock => {
          return _openBlock(), _createElementBlock("div", {
            key: stock.symbol,
            class: "stock-item"
          }, [_createElementVNode("span", _hoisted_18, _toDisplayString(stock.stock_chi_name), 1), _createElementVNode("span", _hoisted_19, _toDisplayString(formatPercent(stock.change_percent * 100)), 1)]);
        }), 128))])], 8, _hoisted_13);
      }), 128))])]), _createElementVNode("div", _hoisted_20, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "sector-header"
      }, "领跌板块", -1)), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sectors.value.bottom_plate_info, plate => {
        var _plate$plate_name2, _plate$led_falling_st;
        return _openBlock(), _createElementBlock("div", {
          key: plate.plate_id,
          class: "data-item",
          onClick: $event => fetchPlateDetails(plate.plate_id)
        }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString((_plate$plate_name2 = plate.plate_name) === null || _plate$plate_name2 === void 0 ? void 0 : _plate$plate_name2.substring(0, 4)), 1), _createElementVNode("span", _hoisted_25, _toDisplayString(formatPercent(plate.core_avg_pcp * 100)), 1)]), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_plate$led_falling_st = plate.led_falling_stocks) === null || _plate$led_falling_st === void 0 ? void 0 : _plate$led_falling_st.items.slice(0, 5), stock => {
          return _openBlock(), _createElementBlock("div", {
            key: stock.symbol,
            class: "stock-item"
          }, [_createElementVNode("span", _hoisted_27, _toDisplayString(stock.stock_chi_name), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(formatPercent(stock.change_percent * 100)), 1)]);
        }), 128))])], 8, _hoisted_22);
      }), 128))])])])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("section", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("h2", _hoisted_32, [_cache[14] || (_cache[14] = _createTextVNode(" 钓什么鱼？ ", -1)), selectedPlateDetails.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(selectedPlateDetails.value.name) + " " + _toDisplayString(formatPercent(selectedPlateDetails.value.avg_pcp * 100)), 1)], 64)) : _createCommentVNode("", true)])]), selectedPlateDetails.value ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPlateDetails.value.industrial_chains, chain => {
        return _openBlock(), _createElementBlock("div", {
          key: chain.id
        }, [_createElementVNode("h5", _hoisted_35, _toDisplayString(chain.name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chain.stock_premium_infos, stock => {
          var _stock$price, _stock$per;
          return _openBlock(), _createElementBlock("div", {
            key: stock.symbol,
            class: "stock-card p-2 border-b border-gray-100 hover:bg-gray-50"
          }, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(stock.stock_chi_name), 1), stock.change_percent !== undefined ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["ml-1 text-base font-bold leading-tight", {
              'text-red-500': stock.change_percent > 0,
              'text-gray-500': stock.change_percent < 0,
              'text-gray-700': stock.change_percent === 0
            }])
          }, _toDisplayString(formatPercent(stock.change_percent * 100)), 3)) : _createCommentVNode("", true)]), stock.last_limit_up && stock.last_limit_up !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(formatTime(stock.last_limit_up)), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_41, _toDisplayString(stock.symbol), 1), _createElementVNode("div", _hoisted_42, [stock.displayLabel ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass({
              'px-1 py-0 text-xs rounded leading-tight': true,
              'bg-green-100 text-green-700': stock.labelEffect === 1,
              'bg-red-100 text-red-700': stock.labelEffect === -1,
              'bg-gray-100 text-gray-700': stock.labelEffect === 0
            })
          }, _toDisplayString(stock.displayLabel), 3)) : _createCommentVNode("", true), stock.isLeading ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(stock.isLeading), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [stock.price !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_46, "现价: " + _toDisplayString((_stock$price = stock.price) === null || _stock$price === void 0 ? void 0 : _stock$price.toFixed(2)), 1)) : _createCommentVNode("", true), stock.turnover_ratio !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_47, "换手: " + _toDisplayString(formatPercent(stock.turnover_ratio * 100)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_48, [stock.per !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_49, "市盈: " + _toDisplayString((_stock$per = stock.per) === null || _stock$per === void 0 ? void 0 : _stock$per.toFixed(2)), 1)) : _createCommentVNode("", true), stock.non_restricted_capital !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_50, "流通: " + _toDisplayString(formatAmount(stock.non_restricted_capital)), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("p", _hoisted_52, _toDisplayString(stock.desc), 1)])])]);
        }), 128))]);
      }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("table", _hoisted_54, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[25] || (_cache[25] = _createElementVNode("th", null, null, -1)), _cache[26] || (_cache[26] = _createElementVNode("th", null, "股票名称", -1)), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[0] || (_cache[0] = $event => handleSort('price'))
      }, [_cache[15] || (_cache[15] = _createTextVNode(" 最新价 ", -1)), _createElementVNode("span", _hoisted_55, _toDisplayString(getSortIcon('price')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[1] || (_cache[1] = $event => handleSort('change_percent'))
      }, [_cache[16] || (_cache[16] = _createTextVNode(" 涨跌幅 ", -1)), _createElementVNode("span", _hoisted_56, _toDisplayString(getSortIcon('change_percent')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[2] || (_cache[2] = $event => handleSort('buy_lock_volume_ratio'))
      }, [_cache[17] || (_cache[17] = _createTextVNode(" 封单比 ", -1)), _createElementVNode("span", _hoisted_57, _toDisplayString(getSortIcon('buy_lock_volume_ratio')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[3] || (_cache[3] = $event => handleSort('turnover_ratio'))
      }, [_cache[18] || (_cache[18] = _createTextVNode(" 换手率 ", -1)), _createElementVNode("span", _hoisted_58, _toDisplayString(getSortIcon('turnover_ratio')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[4] || (_cache[4] = $event => handleSort('non_restricted_capital'))
      }, [_cache[19] || (_cache[19] = _createTextVNode(" 流通市值 ", -1)), _createElementVNode("span", _hoisted_59, _toDisplayString(getSortIcon('non_restricted_capital')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[5] || (_cache[5] = $event => handleSort('total_capital'))
      }, [_cache[20] || (_cache[20] = _createTextVNode(" 总市值 ", -1)), _createElementVNode("span", _hoisted_60, _toDisplayString(getSortIcon('total_capital')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[6] || (_cache[6] = $event => handleSort('first_limit_up'))
      }, [_cache[21] || (_cache[21] = _createTextVNode(" 首次封板 ", -1)), _createElementVNode("span", _hoisted_61, _toDisplayString(getSortIcon('first_limit_up')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[7] || (_cache[7] = $event => handleSort('last_limit_up'))
      }, [_cache[22] || (_cache[22] = _createTextVNode(" 最后封板 ", -1)), _createElementVNode("span", _hoisted_62, _toDisplayString(getSortIcon('last_limit_up')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[8] || (_cache[8] = $event => handleSort('break_limit_up_times'))
      }, [_cache[23] || (_cache[23] = _createTextVNode(" 开板 ", -1)), _createElementVNode("span", _hoisted_63, _toDisplayString(getSortIcon('break_limit_up_times')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[9] || (_cache[9] = $event => handleSort('limit_up_days'))
      }, [_cache[24] || (_cache[24] = _createTextVNode(" 连板 ", -1)), _createElementVNode("span", _hoisted_64, _toDisplayString(getSortIcon('limit_up_days')), 1)])])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedStocks.value, (stock, index) => {
        var _stock$surge_reason;
        return _openBlock(), _createElementBlock("tr", {
          key: stock.symbol
        }, [_createElementVNode("td", _hoisted_65, _toDisplayString(index + 1), 1), _createElementVNode("td", null, [_createVNode(_component_a_popover, {
          placement: "left",
          content: (_stock$surge_reason = stock.surge_reason) === null || _stock$surge_reason === void 0 ? void 0 : _stock$surge_reason.stock_reason,
          trigger: "hover"
        }, {
          content: _withCtx(() => {
            var _stock$surge_reason2;
            return [_createElementVNode("p", null, _toDisplayString((_stock$surge_reason2 = stock.surge_reason) === null || _stock$surge_reason2 === void 0 ? void 0 : _stock$surge_reason2.stock_reason), 1)];
          }),
          default: _withCtx(() => [_createElementVNode("span", _hoisted_66, _toDisplayString(stock.stock_chi_name), 1)]),
          _: 2
        }, 1032, ["content"])]), _createElementVNode("td", null, _toDisplayString(stock.price), 1), _createElementVNode("td", {
          class: _normalizeClass({
            'up': stock.change_percent > 0,
            'down': stock.change_percent < 0
          })
        }, _toDisplayString(formatPercent(stock.change_percent * 100)), 3), _createElementVNode("td", null, _toDisplayString(formatPercent((stock.buy_lock_volume_ratio || 0) * 100)), 1), _createElementVNode("td", null, _toDisplayString(formatPercent((stock.turnover_ratio || 0) * 100)), 1), _createElementVNode("td", null, _toDisplayString(formatAmount(stock.non_restricted_capital)), 1), _createElementVNode("td", null, _toDisplayString(formatAmount(stock.total_capital)), 1), _createElementVNode("td", null, _toDisplayString(formatTime(stock.first_limit_up)), 1), _createElementVNode("td", null, _toDisplayString(formatTime(stock.last_limit_up)), 1), _createElementVNode("td", null, _toDisplayString(stock.break_limit_up_times || 0), 1), _createElementVNode("td", null, _toDisplayString(stock.limit_up_days || 1), 1)]);
      }), 128))])])]))])])]);
    };
  }
};